import { type HTMLAttributes, type ReactElement } from 'react';
import cn from 'classnames';
import classes from './Paragraph.module.css';

type NamedSize = 'default';

export type ParagraphProps = {
  size?: 'sm' | 'md' | 'ml' | 'lg' | NamedSize;
  as?: 'span' | 'p';
} & HTMLAttributes<HTMLParagraphElement>;

export const Paragraph = ({
  size = 'default',
  as: Component = 'p',
  className: givenClassName,
  ...props
}: ParagraphProps): ReactElement => {
  const className = cn(classes[newSizeApiMap[size]], classes.paragraph, givenClassName);
  return <Component className={className} {...props} />;
};

const newSizeApiMap: Record<string, string> = {
  sm: 'sm',
  md: 'md',
  ml: 'ml',
  lg: 'lg',
  default: 'lg',
};
